var defaultStyles = {
  "root": "Base-Typography",
  "no_wrap": "Base-Typography--NoWrap",
  "left": "Base-Typography--Left",
  "center": "Base-Typography--Center",
  "right": "Base-Typography--Right",
  "justify": "Base-Typography--Justify",
  "regular": "Base-Typography--Regular",
  "bold": "Base-Typography--Bold",
  "light": "Base-Typography--Light",
  "pageheading": "Base-Typography--Pageheading",
  "heading": "Base-Typography--Heading",
  "subheading": "Base-Typography--Subheading",
  "body": "Base-Typography--Body",
  "medium": "Base-Typography--Medium",
  "italic": "Base-Typography--Italic",
  "bodyLarge": "Base-Typography--BodyLarge",
  "caption": "Base-Typography--Caption",
  "button": "Base-Typography--Button",
  "label": "Base-Typography--Label",
  "display_xl": "Base-Typography--DisplayXl",
  "display_l": "Base-Typography--DisplayL",
  "display_m": "Base-Typography--DisplayM",
  "display_sm": "Base-Typography--DisplaySm",
  "display_xs": "Base-Typography--DisplayXs",
  "error": "Base-Typography--Error",
  "inverted": "Base-Typography--Inverted"
};

export { defaultStyles as default };
